import { render, staticRenderFns } from "./MyDocumentDetailsMobile.vue?vue&type=template&id=34df87c2&scoped=true&"
import script from "./MyDocumentDetailsMobile.vue?vue&type=script&lang=js&"
export * from "./MyDocumentDetailsMobile.vue?vue&type=script&lang=js&"
import style0 from "./MyDocumentDetailsMobile.vue?vue&type=style&index=0&id=34df87c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34df87c2",
  null
  
)

export default component.exports